import classNames from "classnames";
import InputWrapper from "../../../../../components/Input/InputWrapper";

const Number = ({ settings = {} }) => {
    return (
        <InputWrapper>
            <span className={classNames({"required": settings.required})}>{settings.title}</span>
            <div/>
            {settings.description && <p>{settings.description}</p>}
        </InputWrapper>
    )
};

export default Number;